import { Sentencia} from './sentencia.model';

export class MarcoDeReferencia {

    id: number;
    nombre: string;
    descripcion: string;
    sentencias: Sentencia[];
    tipoFiltro: string;

    /**
     * Constructor
     *
     * @param marco
     */
    constructor(marco)
    {
        {
            this.id = marco.id || null;
            this.nombre = marco.nombre || '';
            this.descripcion = marco.descripcion || '';
            this.tipoFiltro = marco.tipoFiltro || '';
            this.sentencias = marco.sentencias || [];

        }
    }
}
